import React, { useState } from 'react';

const MesOperations= () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  
  const cardData = [
    {
      id: 1,
      icon: "https://ik.imagekit.io/kqumni8l2/MES/Icons/icon%201.png?updatedAt=1745481498842",
      title: "Robust",
      description: "Full set of software built to meet all your requirements."
    },
    {
      id: 2,
      icon: "https://ik.imagekit.io/kqumni8l2/MES/Icons/icon%202.png?updatedAt=1745481498886",
      title: "Smart",
      description: "Report on trends and learn what is working and what you can improve on your plant floor."
    },
    {
      id: 3,
      icon: "https://ik.imagekit.io/kqumni8l2/MES/Icons/icon%20mes%20foe%20website%203.png?updatedAt=1745481498879",
      title: "Secure",
      description: "Technology you can trust to provide you with what you need securely"
    },
    {
      id: 4,
      icon: "📈🚀",
      title: "Flexible",
      description: "Build an MES platform for your specific industry."
    }
  ];

  return (
    <div>
      {/* Main section with background */}
      <div 
        style={{ 
          background: "linear-gradient(135deg, #0099D8 0%, #005CA9 100%)",
          position: "relative",
          overflow: "hidden"
        }}
        className="w-full py-16"
      >
        {/* Background geometric shapes */}
        <div 
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.1,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3E%3Cpolygon points='0,0 100,0 50,100' fill='%23FFFFFF'/%3E%3Cpolygon points='100,0 200,0 150,100 50,100' fill='%23FFFFFF'/%3E%3C/svg%3E")`,
            backgroundSize: "cover",
            zIndex: 0
          }}
        />
        
        {/* Content */}
        <div className="container mx-auto px-4 relative z-10">
          <h2 className="text-3xl font-bold text-white text-center mb-16">
MES to fit your operations – available via cloud or on-premise alter the text</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {cardData.map((card) => (
              <div 
                key={card.id}
                className="relative overflow-hidden bg-white rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl"
                onMouseEnter={() => setHoveredCard(card.id)}
                onMouseLeave={() => setHoveredCard(null)}
              >
                {/* Hover overlay - animated from bottom to top with vibrant gradient */}
                <div 
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: hoveredCard === card.id ? "100%" : "0%",
                    background: "linear-gradient(to top, #0099D8, #0077CC)",
                    transition: "height 0.5s ease-in-out",
                    zIndex: 0,
                    opacity: hoveredCard === card.id ? 0.95 : 0
                  }}
                />
                
                <div className="p-6 relative z-10 h-full flex flex-col">
                  {/* Icon */}
                  <div className="flex justify-center mb-4">
                    {card.id === 1 && (
                      <svg 
                        width="60" 
                        height="60" 
                        viewBox="0 0 24 24" 
                        fill={hoveredCard === card.id ? "#FFFFFF" : "none"} 
                        stroke={hoveredCard === card.id ? "#FFFFFF" : "currentColor"} 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        className={hoveredCard === card.id ? "text-white" : "text-gray-800"}
                        style={{
                          transition: "all 0.5s ease-in-out"
                        }}
                      >
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
                        <polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline>
                        <polyline points="7.5 19.79 7.5 14.6 3 12"></polyline>
                        <polyline points="21 12 16.5 14.6 16.5 19.79"></polyline>
                        <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                        <line x1="12" y1="22.08" x2="12" y2="12"></line>
                      </svg>
                    )}
                    {card.id === 2 && (
                      <svg 
                        width="60" 
                        height="60" 
                        viewBox="0 0 24 24" 
                        fill={hoveredCard === card.id ? "#FFFFFF" : "none"} 
                        stroke={hoveredCard === card.id ? "#FFFFFF" : "currentColor"} 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        className={hoveredCard === card.id ? "text-white" : "text-gray-800"}
                        style={{
                          transition: "all 0.5s ease-in-out"
                        }}
                      >
                        <circle cx="12" cy="12" r="10"></circle>
                        <circle cx="12" cy="12" r="6"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                      </svg>
                    )}
                    {card.id === 3 && (
                      <svg 
                        width="60" 
                        height="60" 
                        viewBox="0 0 24 24" 
                        fill={hoveredCard === card.id ? "#FFFFFF" : "none"} 
                        stroke={hoveredCard === card.id ? "#FFFFFF" : "currentColor"} 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        className={hoveredCard === card.id ? "text-white" : "text-gray-800"}
                        style={{
                          transition: "all 0.5s ease-in-out"
                        }}
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <path d="M9 15l2 2 4-4"></path>
                      </svg>
                    )}
                    {card.id === 4 && (
                      <svg 
                        width="60" 
                        height="60" 
                        viewBox="0 0 24 24" 
                        fill={hoveredCard === card.id ? "#FFFFFF" : "none"} 
                        stroke={hoveredCard === card.id ? "#FFFFFF" : "currentColor"} 
                        strokeWidth="1.5" 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        className={hoveredCard === card.id ? "text-white" : "text-gray-800"}
                        style={{
                          transition: "all 0.5s ease-in-out"
                        }}
                      >
                        <line x1="18" y1="20" x2="18" y2="10"></line>
                        <line x1="12" y1="20" x2="12" y2="4"></line>
                        <line x1="6" y1="20" x2="6" y2="14"></line>
                        <line x1="6" y1="4" x2="18" y2="4"></line>
                      </svg>
                    )}
                  </div>
                  
                  {/* Title */}
                  <h3 
                    className={`text-xl font-bold text-center mb-4 transition-colors duration-500 ${hoveredCard === card.id ? 'text-white' : 'text-gray-800'}`}
                  >
                    {card.title}
                  </h3>
                  
                  {/* Description */}
                  <p 
                    className={`text-center    flex-grow transition-colors duration-500 ${hoveredCard === card.id ? 'text-white' : 'text-gray-600'}`}
                  >
                    {card.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MesOperations;